import type { FC } from 'react'

import type { SxProps, Theme } from '@mui/material'
import { Box, Typography } from '@mui/material'
import { SaveOutlined } from '@mui/icons-material'

import { HOME_CONTENT } from '../defaults'

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const SECTION_HEADING_ID = 'drafts-persistence-heading'

// ---------------------------------------------------------------------------
// Public API
// ---------------------------------------------------------------------------

export const DraftsPersistenceSection: FC = () => (
  <Box
    component="section"
    role="region"
    aria-labelledby={SECTION_HEADING_ID}
    sx={sectionContainerSx}
  >
    <Typography id={SECTION_HEADING_ID} component="h2" sx={sectionTitleSx}>
      {HOME_CONTENT.drafts.title}
    </Typography>

    <Typography sx={sectionSubtitleSx}>{HOME_CONTENT.drafts.description}</Typography>

    <SaveOutlined aria-hidden="true" sx={heroIconSx} />
  </Box>
)

// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------

const sectionContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  py: { xs: 4, md: 6 },
  px: { xs: 2, md: 4 },
}

const sectionTitleSx: SxProps<Theme> = {
  color: 'text.primary',
  fontSize: { xs: '1.5rem', md: '1.75rem' },
  fontWeight: 600,
  textAlign: 'center',
  mb: 1,
}

const heroIconSx: SxProps<Theme> = {
  fontSize: { xs: 80, md: 120 },
  color: 'primary.main',
  opacity: 0.55,
  my: { xs: 2, md: 3 },
}

const sectionSubtitleSx: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: { xs: '1rem', md: '1.1rem' },
  fontWeight: 400,
  textAlign: 'center',
  maxWidth: 540,
}
